// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PrinterOutlinedSvg from "@fishx/icons-svg/es/asn/PrinterOutlined";
import FishxIcon from '../components/FishxIcon';

var PrinterOutlined = function PrinterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PrinterOutlinedSvg
  }));
};

PrinterOutlined.displayName = 'PrinterOutlined';
export default React.forwardRef(PrinterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PrinterOutlined.js
// module id = 3846
// module chunks = 0